// extracted by mini-css-extract-plugin
export var icon = "styles-module--icon--a89f2";
export var layer = "styles-module--layer--c6651";
export var overlay = "styles-module--overlay--022d4";
export var selected = "styles-module--selected--2b491";
export var wrapper = "styles-module--wrapper--cdfde";